import { EmployeeCustomTablesSchemaFieldFragment } from 'generated/resources/graphql'

import { dateBackendToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import type Value from 'modules/custom_resources/store/models/customResources/Value'

const NOT_AVAILABLE = '-'
interface Props {
  schemaEffectiveAtId?: number | null
  field?: EmployeeCustomTablesSchemaFieldFragment | null
  currentValue?: Value
  notAvailable?: string
  companyLocale: string
  currency: string
}

export const getValue = ({
  schemaEffectiveAtId,
  field,
  currentValue,
  notAvailable = NOT_AVAILABLE,
  companyLocale,
  currency,
}: Props): string => {
  if (!field) return notAvailable
  if (!currentValue || !currentValue.has(String(field.id))) {
    return notAvailable
  }

  const value = currentValue?.attributes[String(field.id)]

  if (!value) return notAvailable

  if (schemaEffectiveAtId === field.id || field.fieldType === 'date') {
    return dateBackendToUI(String(value))
  }

  if (field.fieldType === 'multiple_choice') {
    const options: string[] = field.options.map((item) => item.label).filter(Boolean)
    const values = options.filter((item) => String(value).includes(item))

    return values.join(', ')
  }

  if (field.fieldType === 'checkbox') {
    return !value ? i18n.t('custom_resources.basic.no') : i18n.t('custom_resources.basic.yes')
  }

  if (field.fieldType === 'cents') {
    return (Number(value) / 100).toString()
  }

  if (field.fieldType === 'money') {
    return MoneyWithCurrency({
      amount: Number(value),
      currency,
      locale: companyLocale,
    })
  }

  return value
}
